import React, { useState, useEffect, useRef } from 'react';
import { Box, TextField, FormHelperText, Typography } from '@mui/material';
import classes from './MedicareExpiryDatePicker.module.css';

export default function MedicareExpiryDatePicker({
  defaultValue,
  disabled,
  setMedicareExpiryDate,
  index,
  key_prop,
  error = [],
  errorMessage = ''
}) {
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [errorText, setErrorText] = useState('');
  const yearInputRef = useRef(null);

  useEffect(() => {
    if (!defaultValue || defaultValue === 'NA' || defaultValue === 'undefined') {
        setMonth('');
        setYear('');
    } else {
        const parts = String(defaultValue).replace('/', '-').split('-');
        if (parts[0] && parts[0] !== 'NA') setMonth(parts[0].padStart(2, '0'));
        if (parts[1] && parts[1] !== 'NA') setYear(parts[1]);
    }
  }, [defaultValue]);

  const validateAndSubmit = (m, y) => {
    if (!m || !y || m.length < 2 || y.length < 4) {
      setErrorText('Valid MM/YYYY required');
      setMedicareExpiryDate(index, key_prop, null);
    } else {
      const monthInt = parseInt(m, 10);
      const yearInt = parseInt(y, 10);
      
      if (monthInt < 1 || monthInt > 12) {
        setErrorText('Invalid month');
        setMedicareExpiryDate(index, key_prop, null);
        return;
      }
      
      setErrorText('');
      const d = new Date(yearInt, monthInt - 1, 1);
      setMedicareExpiryDate(index, key_prop, { $d: d });
    }
  };

  const handleMonthChange = (e) => {
    let val = e.target.value.replace(/\D/g, '');
    if (val.length > 2) val = val.substring(0, 2);
    setMonth(val);
    
    if (val.length === 2) {
      if (yearInputRef.current) {
        yearInputRef.current.focus();
      }
      validateAndSubmit(val, year);
    } else {
      setMedicareExpiryDate(index, key_prop, null);
    }
  };

  const handleYearChange = (e) => {
    let val = e.target.value.replace(/\D/g, '');
    if (val.length > 4) val = val.substring(0, 4);
    setYear(val);
    
    if (val.length === 4) {
      validateAndSubmit(month, val);
    } else {
      setMedicareExpiryDate(index, key_prop, null);
    }
  };

  const matchedError = error.find((e) => e.index === key_prop);
  const helperText =
    (!defaultValue && !disabled)
      ? 'Medicare Expiry cannot be empty'
      : matchedError
      ? errorMessage
      : errorText;

  const textFieldStyles = {
    bgcolor: 'white',
    '& .MuiOutlinedInput-root': { borderRadius: '8px' },
    '& .MuiInputBase-root': {
        margin: '0px',
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <TextField
          label="MM"
          variant="outlined"
          placeholder="MM"
          value={month}
          onChange={handleMonthChange}
          disabled={disabled}
          sx={{ ...textFieldStyles, width: '45%' }}
          inputProps={{ style: { textAlign: 'center' } }}
        />
        <Typography sx={{ fontWeight: 700, color: '#475569' }}>/</Typography>
        <TextField
          label="YYYY"
          variant="outlined"
          placeholder="YYYY"
          value={year}
          onChange={handleYearChange}
          disabled={disabled}
          inputRef={yearInputRef}
          sx={{ ...textFieldStyles, width: '55%' }}
          inputProps={{ style: { textAlign: 'center' } }}
        />
      </Box>
      <FormHelperText className={classes.FormHelperText} sx={{ color: 'red', mt: 0.5 }}>
        {helperText}
      </FormHelperText>
    </Box>
  );
}
